export const LOCALE_OPTIONS = [
    ['ar', 'Arabic'],
    ['cs', 'Czech'],
    ['da', 'Danish'],
    ['de', 'German'],
    ['el', 'Greek'],
    ['en', 'English'],
    ['es', 'Spanish'],
    ['fi', 'Finnish'],
    ['fr', 'French'],
    ['he', 'Hebrew'],
    ['hi', 'Hindi'],
    ['hu', 'Hungarian'],
    ['id', 'Indonesian'],
    ['it', 'Italian'],
    ['ja', 'Japanese'],
    ['ko', 'Korean'],
    ['nl', 'Dutch'],
    ['no', 'Norwegian'],
    ['pl', 'Polish'],
    ['pt', 'Portuguese'],
    ['pt-br', 'Portuguese (Brazil)'],
    ['ro', 'Romanian'],
    ['ru', 'Russian'],
    ['sv', 'Swedish'],
    ['th', 'Thai'],
    ['tr', 'Turkish'],
    ['uk', 'Ukrainian'],
    ['vi', 'Vietnamese'],
    ['zh-cn', 'Chinese (Simplified)'],
    ['zh-tw', 'Chinese (Traditional)'],
];

export const LOCALE_NAMES = Object.fromEntries(LOCALE_OPTIONS);

export function normalizeLocale(locale) {
    return String(locale || '').trim().toLowerCase().replace(/_/g, '-');
}
